export enum ScreenIds {
  RESOURCES = 'resources',
  SETUP = 'setup',
  DESIGN = 'design',
  INSTRUCTIONS = 'instructions',
  PREVIEW = 'preview',
}
